import * as R from "ramda";
import { Icon } from "antd";
import React, { useEffect } from "react";

import { previewMediaOssBaseUrlWithCdn } from "./widgets/upload-resource";

export function injectAliyunEditorScript() {
  {
    /**
     * 视频剪辑API
     *
     * https://help.aliyun.com/zh/ims/developer-reference/access-the-video-clip-web-sdk?spm=a2c4g.11186623.0.0.3bdb614dwBAoeW
     */
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "//g.alicdn.com/thor-server/video-editing-websdk/5.2.0/index.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src =
      "//g.alicdn.com/thor-server/video-editing-websdk/5.2.0/index.js";
    document.body.appendChild(script);
  }

  {
    /**
     * 视频预览组件
     *
     * https://help.aliyun.com/zh/ims/developer-reference/access-the-preview-component-web-sdk?spm=a2c4g.11186623.0.0.7e9f1228k1m1x2
     */
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "//g.alicdn.com/thor-server/video-editing-websdk/5.0.0/player.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src =
      "//g.alicdn.com/thor-server/video-editing-websdk/5.0.0/player.js";
    document.body.appendChild(script);
  }
}

export const useDisableDuplicateAddResource = () => {
  //  这是一个内部的副作用函数，用来处理阿里云的提示信息 "部分资源重复添加，已自动剔除"
  useEffect(() => {
    //  这个函数是用来检查元素是否包含指定的文本
    function containsText(element, text) {
      return element.textContent.includes(text);
    }

    //  处理变动的函数
    function handleMutations(mutations) {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const targetElement = node.querySelector(
                ".ant-message-notice-content .ant-message-custom-content.ant-message-info span + span"
              );
              if (
                targetElement &&
                containsText(targetElement, "部分资源重复添加，已自动剔除")
              ) {
                node.remove();
              }
            }
          });
        }
      });
    }

    //  创建一个 MutationObserver 实例
    const observer = new MutationObserver(handleMutations);

    //  开始观察 body 的子节点变化
    observer.observe(document.body, { childList: true, subtree: true });

    //  返回一个函数，用来清除观察
    return () => {
      observer.disconnect();
    };
  }, []);
};

export function convertItemToInputMedia(item) {
  const type = R.pathOr("", ["type"], item);
  const mediaId = R.pathOr("", ["aliyun_media_id"], item);
  const mediaType = R.pathOr("", ["type"], item);
  switch (type) {
    case "video":
      return {
        mediaId,
        mediaType,
        video: {
          title: item.name,
          coverUrl: R.pathOr("", ["MediaBasicInfo", "CoverURL"], item),
          duration:
            R.pathOr(
              0,
              ["FileInfoList", 0, "FileBasicInfo", "Duration"],
              item
            ) * 1,
          src: previewMediaOssBaseUrlWithCdn + item.path,
          snapshots: JSON.parse(
            R.pathOr("[]", ["MediaBasicInfo", "Snapshots"], item)
          ),
          width:
            R.pathOr(0, ["FileInfoList", 0, "FileBasicInfo", "Width"], item) *
            1,
          height:
            R.pathOr(0, ["FileInfoList", 0, "FileBasicInfo", "Height"], item) *
            1,
        },
      };
    case "audio":
      return {
        mediaId,
        mediaType,
        audio: {
          title: item.name,
          duration:
            R.pathOr(
              0,
              ["FileInfoList", 0, "FileBasicInfo", "Duration"],
              item
            ) * 1,
        },
      };
    case "image":
      return {
        mediaId,
        mediaType,
        image: {
          title: item.name,
          coverUrl: previewMediaOssBaseUrlWithCdn + item.path,
        },
      };
    default:
      return {
        mediaId,
        mediaType: item.type,
      };
  }
}

export function checkEditorReady(callback = R.T) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (R.path(["AliyunVideoEditor"], window)) {
        clearInterval(interval);
        callback();
        resolve();
      }
    }, 100);
  });
}

export function checkEditorUiReady(callback = R.T) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const button = document.querySelector(
        'div[data-key="material_sidebar"] button'
      );
      if (button) {
        clearInterval(interval);
        callback();
        resolve();
      }
    }, 100);
  });
}

export const getTypeIcon = (type) => {
  const props = {
    className: "color-link",
    style:{
      marginRight: 8,
    },
  }
  switch (type) {
    case "video":
      return <Icon type="video-camera"  {...props} />;
    case "image":
      return <Icon type="picture" {...props} />;
    case "audio":
      return <Icon type="sound" {...props} />;
    case "text":
      return <Icon type="file-text" {...props} />;
    default:
      return <Icon type="file" {...props} />;
  }
};



// WEBPACK FOOTER //
// ./src/containers/Video/compose-util.js